
// import { useState,useEffect } from "react";
// import axios from 'axios';

// export default function ImagePopup() {
//   const [step, setStep] = useState(1);

//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     email: "",
//     property: "",
   
//   });


//   const handleSubmit=async(e) =>{
//    e.preventDefault();

//    if(!isStep2Valid) return;
//   try{
//    const res=await axios.post(`https://api.squareandangle.pranatigroup.in/api/admin/submit`,formData);
//    alert('Saved successfully');

//    setFormData({
//     name: "",
//     phone: "",
//     email: "",
//     property: "",
  
//    })
//    setStep(1);
//   }catch(error){
//  alert('error');
//   }
//   }
 
//   const handleChange = (e) => {
//   const { name, value, type, checked } = e.target;

//   setFormData((prevData) => {
//     const updatedData = {};
//     for (let key in prevData) {
//       updatedData[key] = prevData[key];
//     }
//     updatedData[name] = type === "checkbox" ? checked : value;
//     return updatedData;
//   });
// };


  
//   const isValidPhone = /^[0-9]{10}$/.test(formData.phone);
//   const isStep1Valid =
//     formData.name.trim() !== "" && isValidPhone;

//   const isStep2Valid =
//     formData.email.trim() !== "" &&
//     formData.property.trim() !== "";

 
//   const nextStep = () => {
//     if (!isStep1Valid) return;
//     setStep(2);
//   };

//   const prevStep = () => {
//     setStep(1);
//   };

  

//   return (
//     <div style={styles.container}>
//       <div style={styles.stepCircle}>
//         {step}/2
//       </div>

      
//       {step === 1 && (
//         <>
//           <h2 style={{marginBottom: 29,
//     marginTop: 26}}>Designs for Every Budget</h2>


//           <div style={styles.inputBox}>
//             <input
//               type="text"
//               name="name"
//               placeholder="Name"
//               value={formData.name}
//               onChange={handleChange} style={styles.input}
//             />
//             {formData.name && <span style={styles.tick}>✔</span>}
//           </div>

//           <div style={styles.inputBox}>
//             <input
//               type="text"
//               name="phone"
//               placeholder="Phone"
//               value={formData.phone}
//               onChange={handleChange} style={styles.input}
//             />
//             {isValidPhone && <span style={styles.tick}>✔</span>}
//           </div>

//           <label style={{ display: "block", margin: "10px 0" }}>
//             <input
//               type="checkbox"
//               name="whatsapp"
//               checked={formData.whatsapp}
//               onChange={handleChange}
//             />
//             Send me updates on WhatsApp
//           </label>

//           <button
//             onClick={nextStep}
//             disabled={!isStep1Valid}
//             style={{
//               ...styles.button,
//               backgroundColor: isStep1Valid ? "#e85d5d" : "#ccc"
//             }}
//           >
//             GET FREE QUOTE
//           </button>
//         </>
//       )}

      
//       {step === 2 && (
//         <form>
//           <h2 style={{marginBottom: 29,
//     marginTop: 26}}>Designs for Every Budget</h2>

//           <div style={styles.inputBox}>
//             <input
//               type="email"
//               name="email"
//               placeholder="Email ID"
//               value={formData.email}
//               onChange={handleChange} style={styles.input}
//             />
//             {formData.email && <span style={styles.tick}>✔</span>}
//           </div>

//           <div style={styles.inputBox}>
//             <input
//               type="text"
//               name="property"
//               placeholder="Property Name"
//               value={formData.property}
//               onChange={handleChange} style={styles.input}
//             />
//             {formData.property && <span style={styles.tick}>✔</span>}
//           </div>

//           <div style={{ display: "flex", gap: "10px" }}>
//             <button style={styles.prev} onClick={prevStep}> <svg
//     style={styles.icon}
//     height="16"
//     width="16"
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1024 1024"
//   >
//     <path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z"></path>
//   </svg>

//   <span>Back</span>
//   </button>

//             <button
//               type="submit"
//               disabled={!isStep2Valid}
//               style={{
//                 ...styles.button,
//                 backgroundColor: isStep2Valid ? "#e85d5d" : "#ccc"
//               }} onClick={handleSubmit}
//             >
//               SUBMIT
//             </button>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// }


// const styles = {
//   container: {
//     width: "320px",
//     margin: "50px auto",
//     padding: "20px",
//     borderRadius: "10px",
//     background: "#f5f5f5",
//     position: "relative",
//     fontFamily: "Arial"
//   },
//   inputBox: {
//     position: "relative",
//     marginBottom: "15px"
//   },

//   input :{
//       width: "100%",
//   padding: "12px 40px 12px 14px", 
//   borderRadius: "10px",
//   border: "1px solid #ddd",
//   fontSize: "14px",
//   outline: "none",
//   transition: "all 0.3s ease",
//   backgroundColor: "#fff",
//   boxSizing: "border-box"
//   },
//   tick: {
//     position: "absolute",
//     right: "10px",
//     top: "8px",
//     color: "green"
//   },
//   button: {
//     width: "100%",
//     padding: "12px",
//     border: "none",
//     borderRadius: "25px",
//     color: "#fff",
//     fontWeight: "bold",
//     cursor: "pointer"
//   },
//   stepCircle: {
//     position: "absolute",
//     top: "10px",
//     right: "10px",
//     border: "2px solid red",
//     borderRadius: "50%",
//     padding: "5px 10px",
//     fontSize: "12px"
//   },

//   prev: {
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   gap: "6px",
//   height: "3em",
//   width: "100px",
//   borderRadius: "6px",
//   letterSpacing: "1px",
//   cursor: "pointer",
//   border: "none",
//   background: "#fff",
//   transition: "all 0.2s ease"
// },

// icon: {
//   transition: "all 0.3s ease"
// }
 
// };



import { useState } from "react";
import axios from "axios";

export default function ImagePopup() {
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    property: "",
    whatsapp: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isStep2Valid) return;

    try {
      await axios.post(
        "https://api.squareandangle.pranatigroup.in/api/admin/submit",
        formData
      );

      alert("Saved successfully");

      setFormData({
        name: "",
        phone: "",
        email: "",
        property: "",
        whatsapp: false,
      });

      setStep(1);
    } catch (error) {
      alert("Error submitting form");
      console.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const isValidPhone = /^[0-9]{10}$/.test(formData.phone);

  const isStep1Valid =
    formData.name.trim() !== "" && isValidPhone;

  const isStep2Valid =
    formData.email.trim() !== "" &&
    formData.property.trim() !== "";

  const nextStep = () => {
    if (!isStep1Valid) return;
    setStep(2);
  };

  const prevStep = () => {
    setStep(1);
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>

        
        <div style={styles.stepCircle}>
          {step}/2
        </div>

        <h2 style={styles.heading}>
          Designs for Every Budget
        </h2>

        
        {step === 1 && (
          <div>

            <div style={styles.inputBox}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                style={styles.input}
              />

              {formData.name && (
                <span style={styles.tick}>✓</span>
              )}
            </div>

            <div style={styles.inputBox}>
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                style={styles.input}
              />

              {isValidPhone && (
                <span style={styles.tick}>✓</span>
              )}
            </div>

            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                name="whatsapp"
                checked={formData.whatsapp}
                onChange={handleChange}
              />

              <span>Send me updates on WhatsApp</span>
            </label>

            <button
              type="button"
              onClick={nextStep}
              disabled={!isStep1Valid}
              style={{
                ...styles.button,
                backgroundColor: isStep1Valid
                  ? "#e85d5d"
                  : "#ccc",
              }}
            >
              GET FREE QUOTE
            </button>
          </div>
        )}

        
        {step === 2 && (
          <form onSubmit={handleSubmit}>

            <div style={styles.inputBox}>
              <input
                type="email"
                name="email"
                placeholder="Email ID"
                value={formData.email}
                onChange={handleChange}
                style={styles.input}
              />

              {formData.email && (
                <span style={styles.tick}>✓</span>
              )}
            </div>

            <div style={styles.inputBox}>
              <input
                type="text"
                name="property"
                placeholder="Property Name"
                value={formData.property}
                onChange={handleChange}
                style={styles.input}
              />

              {formData.property && (
                <span style={styles.tick}>✓</span>
              )}
            </div>

            <div style={styles.buttonRow}>

              <button
                type="button"
                onClick={prevStep}
                style={styles.prev}
              >
                <svg
                  style={styles.icon}
                  height="16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1024"
                >
                  <path d="M874.690416 495.52477c0 11.2973-9.168824 20.466124-20.466124 20.466124l-604.773963 0 188.083679 188.083679c7.992021 7.992021 7.992021 20.947078 0 28.939099-4.001127 3.990894-9.240455 5.996574-14.46955 5.996574-5.239328 0-10.478655-1.995447-14.479783-5.996574l-223.00912-223.00912c-3.837398-3.837398-5.996574-9.046027-5.996574-14.46955 0-5.433756 2.159176-10.632151 5.996574-14.46955l223.019353-223.029586c7.992021-7.992021 20.957311-7.992021 28.949332 0 7.992021 8.002254 7.992021 20.957311 0 28.949332l-188.073446 188.073446 604.753497 0C865.521592 475.058646 874.690416 484.217237 874.690416 495.52477z" />
                </svg>

                <span>Back</span>
              </button>

              <button
                type="submit"
                disabled={!isStep2Valid}
                style={{
                  ...styles.button,
                  flex: 1,
                  backgroundColor: isStep2Valid
                    ? "#e85d5d"
                    : "#ccc",
                }}
              >
                SUBMIT
              </button>

            </div>
          </form>
        )}

      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
    boxSizing: "border-box",
  },

  container: {
    width: "100%",
    maxWidth: "360px",
    padding: "20px",
    boxSizing: "border-box",
    borderRadius: "12px",
    background: "#f5f5f5",
    position: "relative",
    fontFamily: "Arial, sans-serif",
    boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
  },

  heading: {
    fontSize: "21px",
    lineHeight: "1.3",
    textAlign: "center",
    margin: "8px 25px 22px",
    color: "#222",
  },

  stepCircle: {
    position: "absolute",
    top: "12px",
    right: "12px",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1.5px solid #e85d5d",
    borderRadius: "50%",
    fontSize: "11px",
    color: "#e85d5d",
    background: "#fff",
    boxSizing: "border-box",
  },

  inputBox: {
    position: "relative",
    marginBottom: "12px",
    width: "100%",
  },

  input: {
    width: "100%",
    height: "44px",
    padding: "10px 38px 10px 12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
    fontSize: "14px",
    outline: "none",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  },

  tick: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#20a020",
    fontSize: "16px",
    fontWeight: "bold",
  },

  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    fontSize: "12px",
    color: "#555",
    margin: "8px 0 16px",
    cursor: "pointer",
  },

  button: {
    width: "100%",
    height: "42px",
    padding: "10px 15px",
    border: "none",
    borderRadius: "22px",
    color: "#fff",
    fontSize: "12px",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    cursor: "pointer",
    boxSizing: "border-box",
  },

  buttonRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "100%",
  },

  prev: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    height: "42px",
    width: "85px",
    flexShrink: 0,
    borderRadius: "7px",
    cursor: "pointer",
    border: "1px solid #ddd",
    background: "#fff",
    color: "#333",
    fontSize: "12px",
  },

  icon: {
    fill: "#333",
  },
};


